import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import PatientTransformer from "@/Modules/Transformers/Patient";
import { get } from "@/Services/TherapyApi/Patients";

import useAppStore from "@/Modules/App/Store";
import useAgentStore from "@/Modules/Agent/Store";

import { danger } from "@/Utils/Debug";

async function fetchPatientsAH() {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  agentStore.isLoadingData = true;

  try {
    const patientsApi = await get();

    agentStore.patients = patientsApi.map(PatientTransformer.toDomain);
  } catch (error) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.isLoadingData = false;
  }
}

export default fetchPatientsAH;
